export class RemoteConfigurationSource {
    constructor(id, name, type, assignmentType, contextKey) {
        this.id = id;
        this.name = name;
        this.type = type;
        this.assignmentType = assignmentType;
        this.contextKey = contextKey;
    }
}
//# sourceMappingURL=RemoteConfigurationSource.js.map